import { useNavigate } from "react-router-dom";
import { useVenueDetailsQuery } from "@ticketingplatform/api/dist/venue";
import { ROUTE_PATHS } from "const/paths";
import { useNumberParams } from "hooks/useNumberParams";
import { useCallback } from "react";

import { useVenueDelete } from "../hooks/useVenueDelete";
import { useVenueShape } from "../hooks/useVenueShape";

import { UseVenueDetailsReturnType } from "./types";

export const useVenueDetails = (): UseVenueDetailsReturnType => {
  const navigate = useNavigate();
  const { id } = useNumberParams(true);
  const { data, loading } = useVenueDetailsQuery({ variables: { id } });
  const { deleteVenue } = useVenueDelete();

  return {
    loading,
    initialValues: useVenueShape(data?.venue),
    onDelete: useCallback(async () => {
      await deleteVenue(id);
      navigate(ROUTE_PATHS.VenuesList);
    }, [deleteVenue, id, navigate]),
  };
};
